export enum ZuersZoneEnum {
  EINS = '1',
  ZWEI = '2',
  DREI = '3',
  VIER = '4',
  AAWORLD = '98',
}

export interface ElementarSelbstbehalt {
  id: ZuersZoneEnum;
  description: string;
}

export function convertBffZuersZoneIdtoZuersZoneEnum(id: string): ZuersZoneEnum {
  const isEnumValue = Object.values(ZuersZoneEnum)
    .map(value => value.toString())
    .includes(id);
  if (isEnumValue) {
    return id as ZuersZoneEnum;
  } else {
    throw new Error(`BffZuersZone '${id}' kann nicht zu FE-ZuersZoneEnum konvertiert werden`);
  }
}
